export const newPedigreeEN = {
  'Cancel': 'Cancel',
  'Next': 'Next',
  'Add New Family':'Add New Family',
  'New Pedigree':'New Pedigree',
  'Add New Pedigree':'Add New Pedigree',
  'Launch New Questionnaire':'Launch New Questionnaire',
  'Launch Questionnaire':'Launch Questionnaire',
  'Draw Now':'Draw Now',
  'Pedigree name already exists': 'Pedigree name already exists',
  'Failed to check pedigree name': 'Failed to check pedigree name',
  Previous: 'Previous',
  'Select a Questionnaire': 'Select a Questionnaire',
  'Pedigree Name:': 'Pedigree Name:',
  'Sex': 'Sex',
  'Male': 'Male',
  'Female': 'Female',
  'Enter the number for each Proband relative:': 'Enter the number for each Proband relative:',
  'Questionnaire Name': 'Questionnaire Name',
  'Datasheet Format Name': 'Datasheet Format Name',
  'Folder Name:': 'Folder Name:',
  'Brothers': 'Brothers',
  'Sisters': 'Sisters',
  'Sons': 'Sons',
  'Daughters': 'Daughters',
  'Paternal Uncles': 'Paternal Uncles',
  'Paternal Aunts': 'Paternal Aunts',
  'Maternal Uncles': 'Maternal Uncles',
  'Maternal Aunts': 'Maternal Aunts',
  'Specify name of new pedigree': 'Specify name of new pedigree',
  'FHQ Version' : 'FHQ Version',
};